import React from 'react';
import RiskHistoryScreen from './screens/RiskHistory/RiskHistoryScreen';

function RiskHistory() {
  return <RiskHistoryScreen />;
}

export default RiskHistory;
